import {RouteType} from '../ui/button'

export interface CoreButtonProps {
    children?: React.ReactNode
    ctaType?: 'link' | 'button' | null
    attributes?: Record<string, any>
    clickFunction: string
    scrollTargetId?: string
    isInternalLink?: boolean
    isRevShare?: boolean
    openInNewTab?: boolean
    url?: string
    routeType?: RouteType
    queryParams?: Array<{
        name: string
        value: string
    }>
    dataTestId?: string
}

export const buttonFunctions = {
    linkToPage: 'Link to Page',
    linkToElement: 'Link to Element',
    nothing: 'Nothing'
}

export const appendSearchParams = ({
    url,
    queryParamData,
    clickFunction,
    scrollTargetId
}: {
    url?: string
    scrollTargetId?: string
    queryParamData?: Array<{name: string; value: string}>
    clickFunction: string
}): string | undefined => {
    if (clickFunction === buttonFunctions.nothing) {
        return
    }

    if (clickFunction === buttonFunctions.linkToElement && scrollTargetId) {
        return `#${scrollTargetId}`
    }
    const queryParams = queryParamData
        ?.filter(({name, value}) => name && value)
        .map(({name, value}) => [name, value])

    const urlSearchParams = new URLSearchParams(queryParams).toString()
    const searchParams = urlSearchParams ? `?${urlSearchParams}` : ''

    return url ? `${url}${searchParams}` : '/'
}
